import styled from 'styled-components';

export const TabsHeaderContainer = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 12px;
`;

export const TabButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 12px;
  background: transparent;
  border: none;
  border-bottom: 2px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.red.default : theme.colors.lightGray};
  color: ${({ theme }) => theme.colors.neutral.dark};
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  word-wrap: break-word;
  cursor: pointer;

  &:hover {
    border-bottom-color: ${({ theme, $active }) =>
      $active ? theme.colors.red.default : theme.colors.neutral.default};
  }
`;

export const WppModalText = styled.div`
  ol {
    padding-left: 17px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  p {
    color: #3d3d3d;
    font-size: 14px;
    font-family: Poppins;
    margin: 0;
  }
`;

// <-- Connection Card Styles -->
export const StyledConnectionCard = styled.div`
  width: 100%;
  padding: 12px;
  background: #f6f6f6;
  overflow: hidden;
  border-radius: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const StyledRowContainer = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  display: inline-flex;
`;

export const StyledLabel = styled.span`
  color: #545454;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;

export const StyledValue = styled.span`
  color: #222222;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
  flex: 1;
  text-align: right;
`;

// <-- QR Connection Area -->

export const QRConnectionAreaContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 8px;
  gap: 16px;
  background: #f6f6f6;
  overflow: hidden;
  border-radius: 12px;
`;

export const WppModalTitle = styled.h1`
  padding: 8px;
  color: #3d3d3d;
  font-size: 16px;
  font-family: Poppins;
  font-weight: 700;
  margin: 0 0 4px;
`;
